'use client'
import React, {useEffect, useRef, useState} from "react";
import usePreventZoom from "../../hooks/usePreventZoom";
import IMG from "../../constants/image";
import {uploadImage} from "../../network/api";

const Avatar = ({onUpload, image, viewOnly}) => {
  usePreventZoom()
  const [avatar, setAvatar] = useState(image || IMG.userCircle);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  useEffect(() => {
    setAvatar(image);
  }, [image]);

  const handleAvatarClick = () => {
    if (viewOnly) return;
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    if (viewOnly) return;
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/heic"];
    const maxSize = 25 * 1024 * 1024; // 25MB
    if (file) {
      if (allowedTypes.includes(file.type) && file.size <= maxSize) {
        try {
          const uploadData = await uploadImage({files: [file]});
          if (uploadData && uploadData.length > 0) {
            const processedFile = uploadData[0];
            const reader = new FileReader();
            reader.onload = (e) => {
              setAvatar(e.target.result);
              setError("");
            };
            onUpload && onUpload(processedFile);
            reader.readAsDataURL(processedFile);
          }
        } catch (e) {
          setError(e?.message || "Dung lượng ảnh vượt quá giới hạn cho phép. Vui lòng kiểm tra lại.");
          if (fileInputRef.current) fileInputRef.current.value = '';
        }
      } else {
        setError(
          "Vui lòng chọn file ảnh có định dạng jpeg, png hoặc heic và kích thước không quá 25MB"
        );
      }
    }

  };

  return (
    <div className="w-fit cursor-pointer">
      <div className="relative group w-[84px]">
        <img
          src={avatar || IMG.userCircle}
          alt="User avatar"
          className="w-20 h-20 rounded-full duration-300 group-hover:scale-105"
        />
        {
          !viewOnly &&
          <div
            className="absolute bottom-0 right-0 rounded-full cursor-pointer hover:bg-blue-600"
            onClick={handleAvatarClick}
          >
            <img src={IMG.icon.cameraCircle} alt="camera"/>
          </div>
        }

      </div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/jpeg,image/png,image/gif"
        className="hidden"
        aria-label="Upload avatar image"
      />
      {error && (
        <p className="text-[#FF0019]/70 text-sm mt-2 text-center animate-fade-in">
          {error}
        </p>
      )}
    </div>
  );
};

export default Avatar;
